import EnterpriseRouter from './Enterprise.router';
export default EnterpriseRouter;

export { default as enterpriseRouterRoutes } from './routes';
